import { useEffect, useMemo, useState } from 'react';
import { useCategories } from '@/hooks/useCategories';
import { shopCategoryHref } from '@/lib/categoryHelpers';
import { listShopDepartmentCategories } from '@/lib/shopCategories';
import {
  getRuntimeHomepageHero,
  heroConfigToCarouselSlides,
  subscribeHomepageHero,
} from '@/lib/platformHeroConfig';
import type { CarouselSlide } from '@/components/HeroCarousel';
import { DEFAULT_HERO_INTERVAL_MS } from '@shopgnd/shared';
import {
  MARKETPLACE_HERO_SUB,
  MARKETPLACE_HERO_TAGLINE,
  MARKETPLACE_TAGLINE,
} from '@/lib/seo/constants';

export function useHomepageHero(): { slides: CarouselSlide[]; intervalMs: number } {
  const categories = useCategories();
  const [heroVersion, setHeroVersion] = useState(0);

  useEffect(() => subscribeHomepageHero(() => setHeroVersion((v) => v + 1)), []);

  return useMemo(() => {
    const config = getRuntimeHomepageHero();
    const shopCats = listShopDepartmentCategories(categories);
    const categoryPills = shopCats.slice(0, 4).map((c) => ({
      label: c.name,
      to: shopCategoryHref(c),
    }));

    return {
      slides: heroConfigToCarouselSlides(config, { categoryPills }),
      intervalMs: config.intervalMs ?? DEFAULT_HERO_INTERVAL_MS,
    };
  }, [categories, heroVersion]);
}

/** Brand slide copy for the static HTML hero shell (keep in sync with seo/constants). */
export function staticHomeHeroCopy() {
  return {
    badge: 'ShopGND',
    headline: MARKETPLACE_TAGLINE,
    tagline: MARKETPLACE_HERO_TAGLINE,
    sub: MARKETPLACE_HERO_SUB,
  };
}
